<template>
  <div class="error form__results form__results_block_error">
    <div class="error__wrapper">
      <p class="error__text">
        {{label ? label : 'Something went wrong... Please try again later'}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorBlock',
  props: {
    label: String,
  },
}
</script>
